import styled from 'styled-components';

export const Wrapper = styled.ul`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	gap: 5rem;
`;
